module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAcCAYAAAB/E6/TAAAAAXNSR0IArs4c6QAAARJJREFUSEvtlsFNxEAMRf2j3KEE6CBUAHQCtyjxhQpIB3DwId3AVsB2sJSQvU/y0axCFKJIM4HNifg6/n7yH2s8UNVKRJ5lxSD5BFXlioyh9AA6UYH9OaEkMwAvvua4o3szez8nSFXvRORtAy12dbNusWXfgs26zbrBgX8yDCT3AJpf3/yMkOQlgGz6ekcxuq57BOALnPZMbCzdsDsz8ztGVNXvrttoUFmWDYCLWAHJB9+RiLwu0BxRFIVft1UvDmmnHexCApINyQqhxPH59CNjZtH66MT+Xn78mFYB5Xl+labpYdyhc+66ruvPGFeCHfWADxHxAzAXjXPuJgQMgvywJEniQbNB8ti2bfZnUIwtMTlfatPJZk5gizwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preview/pc-select.png
// module id = YWGJ
// module chunks = 1